import ManageDiscontinuanceDescription from '../../../views/Personnel/Letter/ManageDiscontinuanceDescription.letter.view';

export default ManageDiscontinuanceDescription;
